import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import PageHeader from '../components/PageHeader';
import usePageSearchIndex from '../hooks/usePageSearchIndex';
import './Awards.css';

const Awards = () => {
  const { isMarathi } = useLanguage();

  usePageSearchIndex({
    mr: ['पुरस्कार', 'विश्वकर्मा', 'गुणवंत', 'कामगार भूषण', 'कामगार मित्र'],
    en: ['awards', 'vishwakarma', 'meritorious', 'labour excellence', 'labour friend']
  });

  const pageHeaderData = {
    title: {
      marathi: 'पुरस्कार',
      english: 'Awards'
    },
    subtitle: {
      marathi: 'मंडळाच्या विविध पुरस्कार व मान्यता',
      english: 'Various awards and recognition of the board'
    }
  };

  return (
    <div className="awards">
      <div className="awards-container">
        {/* Page Header */}
        <PageHeader 
          title={pageHeaderData.title}
          subtitle={pageHeaderData.subtitle}
        />

        {/* Main Content */}
        <div className="awards-content">
          {/* Awards Table */}
          <section className="awards-section">
            <div className="awards-table-container">
              <table className="awards-table">
                <thead>
                  <tr>
                    <th>
                      {isMarathi() ? 'अनुक्रमांक' : 'Serial No.'}
                    </th>
                    <th>
                      {isMarathi() ? 'पुरस्कार' : 'Award'}
                    </th>
                    <th>
                      {isMarathi() ? 'परिपत्रक' : 'Circular'}
                    </th>
                    <th>
                      {isMarathi() ? 'फॉर्म' : 'Form'}
                    </th>
                    <th>
                      {isMarathi() ? 'दिनांक' : 'Date'}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="award-serial">
                      {isMarathi() ? '१' : '1'}
                    </td>
                    <td className="award-details">
                      {isMarathi() ? 'विश्वकर्मा आदर्श कामगार पुरस्कार ( पूर्वीचा गुणवंत कामगार पुरस्कार नामकरण )' : 'Vishwakarma Ideal Labour Award (Formerly named Meritorious labour Award)'}
                    </td>
                    <td className="award-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/awards/vishwakarma_adarsha_kamgar_puraskar_purvicha_gunvant_puraskar_namkaran.pdf" 
                        className="award-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="award-na">NA</td>
                    <td className="award-date">
                      {isMarathi() ? '१०/१०/२०१८' : '10/10/2018'}
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="award-serial">
                      {isMarathi() ? '२' : '2'}
                    </td>
                    <td className="award-details">
                      {isMarathi() ? 'गुणवंत कामगार कल्याण पुरस्कार' : 'Meritorious Labour Welfare Award'}
                    </td>
                    <td className="award-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/awards/gunvant_kamgar_puraskar_kamgar_bhaushan_purashkar_pariptrak.pdf" 
                        className="award-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="award-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/awards/gunvant_kamgar_puraskar_form.pdf" 
                        className="award-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="award-date">
                      {isMarathi() ? '२१/११/२०१५' : '21/11/2015'}
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="award-serial">
                      {isMarathi() ? '३' : '3'}
                    </td>
                    <td className="award-details">
                      {isMarathi() ? 'कामगार भूषण पुरस्कार' : 'Labour Excellence Award'}
                    </td>
                    <td className="award-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/awards/gunvant_kamgar_puraskar_kamgar_bhaushan_purashkar_pariptrak.pdf" 
                        className="award-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="award-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/awards/kamgar_bhushan_puraskar_form.pdf" 
                        className="award-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="award-date">
                      {isMarathi() ? '२१/११/२०१५' : '21/11/2015'}
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="award-serial">
                      {isMarathi() ? '४' : '4'}
                    </td>
                    <td className="award-details">
                      {isMarathi() ? 'रावबहाददूर नारायण मेघाजी लोखंडे कामगार मित्र पुरस्कार' : 'Raobahadur Narayan Meghaji Lokhande Labour Friend Award'}
                    </td>
                    <td className="award-more-info">
                      <a 
                        href="https://mlwb.in/react-static-files/pdf/awards/kamgar_mitra_puraskar_mahiti.pdf" 
                        className="award-link" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        title={isMarathi() ? 'विवरणासाठी क्लिक करा' : 'Click for Details'}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    </td>
                    <td className="award-na">NA</td>
                    <td className="award-date">
                      {isMarathi() ? '१५/०६/२०१६' : '15/06/2016'}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          {/* Navigation Buttons */}
          <section className="awards-navigation">
            <div className="navigation-buttons">
              <Link to="/schemes" className="nav-button">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {isMarathi() ? 'योजना' : 'Schemes'}
              </Link>
              <Link to="/activities" className="nav-button">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 11H15M9 15H15M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L19.7071 9.70711C19.8946 9.89464 20 10.149 20 10.4142V19C20 20.1046 19.1046 21 18 21H17ZM17 21V10H13V6H7V19H17Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {isMarathi() ? 'उपक्रम' : 'Activities'}
              </Link>
              <Link to="/programs" className="nav-button">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 11H15M9 15H15M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L19.7071 9.70711C19.8946 9.89464 20 10.149 20 10.4142V19C20 20.1046 19.1046 21 18 21H17ZM17 21V10H13V6H7V19H17Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {isMarathi() ? 'कार्यक्रम' : 'Programs'}
              </Link>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Awards;
